var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form-item',{attrs:{"prop":_vm.prop,"label":_vm.label,"description":_vm.description,"hint":_vm.hint,"rules":_vm.rules,"error":_vm.error},scopedSlots:_vm._u([{key:"label",fn:function(){return [_vm._t("label")]},proxy:true}],null,true)},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-78b98060","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/common/components/rest/RestFormItem.vue
// module id = null
// module chunks = 